/**
 * The error text for a reclassify whose doc-level recompute failed on some documents
 * (DR-5290), or `undefined` when every document rebuilt. Each listed document needs a
 * classification retry from its document page.
 */
export function reclassifyFailedDocumentsMessage(failedDocumentIds: string[] | undefined): string | undefined {
  if (!failedDocumentIds?.length) return undefined;
  return `Reclassify saved the page rankings, but ${failedDocumentIds.length} document(s) did not rebuild. Retry classification on: ${failedDocumentIds.join(', ')}`;
}

export const EXCLUDED_CATEGORY_RECLASSIFY_MESSAGE = 'Reclassify did not run. This category is excluded.';

/** Toast for one reclassify response. `success: false` means the server skipped an excluded category. */
export function reclassifyResultToast(data: {
  success: boolean;
  failedDocumentIds?: string[];
}): { level: 'error' | 'success'; message: string } {
  if (data.success === false) {
    return { level: 'error', message: EXCLUDED_CATEGORY_RECLASSIFY_MESSAGE };
  }
  const failedMessage = reclassifyFailedDocumentsMessage(data.failedDocumentIds);
  if (failedMessage) {
    return { level: 'error', message: failedMessage };
  }
  return { level: 'success', message: 'Category reclassified successfully' };
}

/** Error text for one batch item, or undefined when that item completed. */
export function reclassifyBatchError(data: {
  success: boolean;
  failedDocumentIds?: string[];
}): string | undefined {
  const result = reclassifyResultToast(data);
  return result.level === 'error' ? result.message : undefined;
}
